export default __webpack_public_path__ + "static/media/plus-square-dotted.eb6c0db6.svg";